import React from 'react';
import ButtonComponent from '../../../../../components/Buttons/ButtonComponent';
import Grid from '@mui/material/Grid';
import CustomizeButtonComponent from '../../../../../components/Buttons/CustomizeButtonComponent';

const ButtonBankAdvanceSettlement = ({
    ReloadData,
    DataRegUserAccess,
    AddBAS,
    EditBAS,
    DeleteData,
    Print,
    RePrint,
    DropDownTitle,
    HandleStatus
}) => {

    const renderButton = (data) => {
        switch (data.accessCode) {
            case 'CRE':
                return ButtonComponent.AddButton(AddBAS, 'New');
            case 'REI':
                return ButtonComponent.EditButton(EditBAS, 'Data');
            case 'DEL':
                return DropDownTitle !== 'Deleted' ? ButtonComponent.DeleteButton(DeleteData, 'Data') : null;
            case 'PRI':
                return DropDownTitle !== 'Deleted' ? ButtonComponent.PrintButton(Print) : null;
            case 'RPR':
                return DropDownTitle !== 'Deleted' ? ButtonComponent.ReprintButton(RePrint, 'Approval') : null;
            default:
                return null;
        }
    };

    return (
        <div className="row">
            <div className="col-12">
                <Grid container item spacing={1} direction="row" style={{ maxWidth: '100vw', margin: '0px', columnGap: '8px', rowGap: '10px' }}>
                    {ButtonComponent.ReloadButton(ReloadData)}

                    {DataRegUserAccess.map((data) => (
                        <React.Fragment key={data.accessId}>
                            {renderButton(data)}
                        </React.Fragment>
                    ))}
                    
                    {CustomizeButtonComponent.DropDownButtonStatus(HandleStatus, DropDownTitle)}
                </Grid>
            </div>
        </div>
    );
};

export default ButtonBankAdvanceSettlement;